// Analytics Configuration
// Debug: Add ?debug_analytics=true to URL to see config in console
if (typeof window !== 'undefined' && window.location.search.includes('debug_analytics=true')) {
  console.log('🔍 Analytics Config Debug:', {
    mixpanel: {
      enabled: process.env.REACT_APP_MIXPANEL_ENABLED,
      hasToken: !!process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN,
      tokenPrefix: process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN?.substring(0, 8) + '...'
    },
    ga4: {
      enabled: process.env.REACT_APP_ANALYTICS_ENABLED,
      measurementId: process.env.REACT_APP_GA4_MEASUREMENT_ID
    },
    nodeEnv: process.env.NODE_ENV
  });
}

export const analyticsConfig = {
  // Google Analytics 4
  ga4: {
    measurementId: process.env.REACT_APP_GA4_MEASUREMENT_ID || '',
    enabled: process.env.REACT_APP_ANALYTICS_ENABLED === 'true',
    debug: process.env.NODE_ENV === 'development'
  },

  // Supabase Configuration
  supabase: {
    url: process.env.REACT_APP_SUPABASE_URL || '',
    anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
    enabled: process.env.REACT_APP_SUPABASE_ANALYTICS_ENABLED === 'true'
  },

  // Mixpanel Configuration
  mixpanel: {
    projectToken: process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN || '',
    enabled: process.env.REACT_APP_MIXPANEL_ENABLED === 'true',
    debug: process.env.NODE_ENV === 'development'
  },
  
  // Privacy Settings
  privacy: {
    anonymizeIp: true,
    cookieFlags: 'SameSite=Strict;Secure',
    sessionTimeout: 30 * 60 * 1000, // 30 minutes
    requireConsent: false // No consent needed - Supabase doesn't use cookies!
  },
  
  // Event Names (centralized for consistency)
  events: {
    // Search Events
    SEARCH_ARTIST: 'search_artist',
    SEARCH_RESULT_CLICKED: 'search_result_clicked',
    SEARCH_NO_RESULTS: 'search_no_results',
    
    // Playlist Events
    PLAYLIST_CREATED: 'playlist_created',
    PLAYLIST_SAVED: 'playlist_saved',
    PLAYLIST_COPIED: 'playlist_copied',
    PLAYLIST_PLAYED: 'playlist_played',
    
    // Share Events
    SHARE_OPENED: 'share_opened',
    SHARE_INSTAGRAM: 'share_instagram',
    SHARE_COPY_LINK: 'share_copy_link',
    
    // Error Events
    ERROR_OCCURRED: 'error_occurred',
    API_ERROR: 'api_error',
    
    // User Events
    USER_SIGNUP: 'user_signup',
    USER_LOGIN: 'user_login',
    SESSION_START: 'session_start',
    SESSION_END: 'session_end'
  }
};

// Type definitions for analytics events
export interface AnalyticsEvent {
  name: string;
  parameters?: Record<string, any>;
  timestamp?: number;
  sessionId?: string;
  userId?: string;
}

export interface ErrorEvent {
  error: Error;
  errorInfo?: any;
  context?: Record<string, any>;
  severity: 'low' | 'medium' | 'high' | 'critical';
}

export interface SearchEvent {
  query: string;
  artist?: string;
  resultsCount?: number;
  searchType: 'manual' | 'suggestion' | 'auto';
  timeToResults?: number;
}

export interface PlaylistEvent {
  artistName: string;
  artistId?: string;
  songCount: number;
  platform: 'spotify' | 'apple_music';
  playlistId?: string;
  action: 'created' | 'saved' | 'copied' | 'played';
}

export interface ShareEvent {
  method: 'instagram' | 'facebook' | 'twitter' | 'reddit' | 'copy_link';
  artistName: string;
  playlistId?: string;
  success: boolean;
}